// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"976a430f","214":"df8d4c83","453":"26a903e1","459":"e3f34ef2","528":"5f3cb25f","779":"9ac12ff1","781":"fba4c1b0","865":"cfa30b79","899":"d95e32c0","951":"f23fb0e3"}[chunkId] + ".chunk.js";
};